import { useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";

import Loading from "../../../../components/Loading";
import Menu from "../../../../components/Menu";

import api from "../../../../services/api";

export default function HistoricoTemperatura() {
    const [data, setData] = useState([]);

    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());

    const [isLoading, setIsLoading] = useState(false);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const handleDelete = (rowData) => {
        confirmDialog({
            header: "Excluir",
            message: "Você tem certeza que deseja excluir esse registro?",
            acceptLabel: 'Excluir',
            acceptClassName: 'p-button-danger',
            rejectLabel: "Cancelar",
            rejectClassName: "p-button-secondary",
            accept: () => {
                setIsLoading(true);
                api.delete(`acabamento/temperatura/${rowData.id}/delete`).then(response => {
                    handleSearch();
                    setIsLoading(false);
                    showSuccess(response);
                }).catch(error => {
                    setIsLoading(false);
                    showError(error);
                });
            }
        });
    }

    const handleEdit = (rowData) => {
        window.open(`/acabamento/temperatura/${rowData.id}`);
    }

    const handleSearch = () => {
        let date1 = `${String(initialDate.getFullYear())}-${String(initialDate.getMonth() + 1).padStart(2, '0')}-${String(initialDate.getDate()).padStart(2, '0')}`;
        let date2 = `${String(finalDate.getFullYear())}-${String(finalDate.getMonth() + 1).padStart(2, '0')}-${String(finalDate.getDate()).padStart(2, '0')}`;

        setIsLoading(true);
        api.get('acabamento/temperatura', {
            params: {
                data_inicial: date1,
                data_final: date2
            }
        }).then(response => {
            setIsLoading(false);
            setData(response.data);
        }).catch(error => {
            setIsLoading(false);
            showError(error);
        });
    }

    if(isLoading)
        return <Loading />

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card
                className="p-m-1"
                title="Histórico - Temperatura"
            >
                <div className="p-d-flex p-flex-row p-jc-start">
                    <Calendar 
                        className="p-m-1"
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        onChange={e => setInitialDate(e.value)}
                        placeholder="Data Inicial"
                        value={initialDate}
                    />

                    <Calendar 
                        className="p-m-1"
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        onChange={e => setFinalDate(e.value)}
                        placeholder="Data Final"
                        value={finalDate}
                    />

                    <Button 
                        className="p-m-1 p-button-success"
                        icon="pi pi-search"
                        onClick={handleSearch}
                    />
                </div>

                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    responsiveLayout="scroll"
                    size="small"
                    value={data}
                >
                    <Column header="ID" field="id" sortable />
                    <Column header="Data" field="dataf" sortable />
                    <Column header="Rolo" field="rolo" sortable />
                    <Column header="Operador" field="operador" sortable /> 
                    <Column header="Umi. I." field="umidade_inicial" sortable /> 
                    <Column header="Umi. F." field="umidade_final" sortable /> 
                    <Column header="Manchão" field="manchao" sortable /> 
                    <Column header="Feltro" field="feltro" sortable /> 
                    <Column header="Valores" field="temperaturas_string" body={(rowData) => {
                        let exploded = String(rowData.temperaturas_string).split(';');
                        return (
                            exploded.map((item, index) => (
                                <div>
                                    <span >{item}</span>
                                    <br />
                                </div>
                            ))
                        )
                        
                    }} style={{ fontSize: 24 }} />
                    <Column header="Ações" body={(rowData) => (
                        <div>
                            <Button 
                                className="p-button-primary p-m-1"
                                icon="pi pi-pencil"
                                onClick={() => handleEdit(rowData)}
                            />
                            <Button 
                                className="p-button-danger p-m-1"
                                icon="pi pi-trash"
                                onClick={() => handleDelete(rowData)}
                            />
                        </div>
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}